class PlanSelector extends HTMLElement
{
  constructor() {
    super();
    this.listeners();
    this.setInitialSellingPlan();
  }

  open() {

  }

  close() {

  }

  setInitialSellingPlan() {
    var spdefault = this.querySelector('input[name="set-selling-plan"]');
    if(spdefault) {
      let plan_id = spdefault.value;
      var self = this;
      if(self.dataset.section == "collection" || 
        self.dataset.section == "collection-subscription" ||
        self.dataset.section == "template-subscriptions-collection-one" ||
        self.dataset.section == "template-subscriptions-collection-two" ||
        self.dataset.section == "template-subscriptions-collection-three"
      ) {
        var sp = document.querySelector(`#product-form-${self.dataset.uniqueid} #selling_plan`);
      }else{
        var sp = document.querySelector(`#product-form-${self.dataset.section} #selling_plan`);
      }
      sp.value = plan_id;
    }
  }

  listeners() {

    // var planRadios = this.querySelectorAll('[data-single-plan-selector]');

    // var self = this;
    // planRadios.forEach(function(e){
    //   e.addEventListener('change', function(event) {
    //     //get selected plan
    //     if(self.dataset.section == "collection" || 
    //       self.dataset.section == "collection-subscription" ||
    //       self.dataset.section == "template-subscriptions-collection-one" ||
    //       self.dataset.section == "template-subscriptions-collection-two" ||
    //       self.dataset.section == "template-subscriptions-collection-three"
    //     ) {
    //       var sp = document.querySelector(`#product-form-${self.dataset.uniqueid} #selling_plan`);
    //     }else{
    //       var sp = document.querySelector(`#product-form-${self.dataset.section} #selling_plan`);
    //     }
    //     let plan_id = event.target.value;
    //     sp.value = plan_id;
        
        
    //   });
    // });

    var planSelectElement = this.querySelector('[data-single-plan-selector]');
    var self = this;
    planSelectElement.addEventListener('change', function(event) {
      //get selected plan
      if(self.dataset.section == "collection" || 
        self.dataset.section == "collection-subscription" ||
        self.dataset.section == "template-subscriptions-collection-one" ||
        self.dataset.section == "template-subscriptions-collection-two" ||
        self.dataset.section == "template-subscriptions-collection-three"
      ) {
        var sp = document.querySelector(`#product-form-${self.dataset.uniqueid} #selling_plan`);
      }else{
        var sp = document.querySelector(`#product-form-${self.dataset.section} #selling_plan`);
      }
      let plan_id = event.target.value;
      sp.value = plan_id;
      window.gwp_selling_plan = plan_id;
    });



    var purchaseOptionSelector = this.querySelectorAll('[data-purchase-option-selector]');
    purchaseOptionSelector.forEach(function(el){
      el.addEventListener('change', function(){
        self.onPlanTypeChange(event.target.value);
      });
    });

    var detailsModal = this.querySelector('[data-subscribe-modal-trigger]');
    if(detailsModal != null) {    
      detailsModal.addEventListener('click', function(el){
        event.preventDefault();
        self.querySelector('[data-subscribe-modal]').classList.add('is--active');
      });
      this.querySelector('[data-subscribe-modal-close]').addEventListener('click', function(el){
        self.querySelector('[data-subscribe-modal]').classList.remove('is--active');
      });
    }

    document.addEventListener('click', function(e) {
      console.log(e.target.closest('.plan-selector__modal'));

      if(e.target.closest('.subscribe-modal-trigger-icon') === null && e.target.closest('.plan-selector__modal') === null) {
        if(document.querySelector('.plan-selector__modal')) {
          document.querySelector('.plan-selector__modal').classList.remove('is--active');
        }
      }
    });

  }

  setPrice(price) {
    //set price
    var prices = document.querySelectorAll('.product-single__price [data-product-price]');
    prices.forEach(function(el){
      el.innerText = price;
    });

    //set points price
    var pointCTAs = document.querySelectorAll('[data-product-points]');
    
    pointCTAs.forEach(function(el){

      //get multiplier
      price = price.replace("$","");

      let multiply = el.getAttribute('data-multiplier');
      if(multiply) {
        el.innerText = Math.ceil(price * multiply);
      }else{
        el.innerText = Math.ceil(price);
      }
    });

    let purchaseOptionSelectors = document.querySelectorAll('[data-purchase-option-selector]');
    let priceSaving = document.querySelector('.product-single__price--saving');

    purchaseOptionSelectors.forEach(selector => {
      if(selector.checked){
        if(selector.id == 'subsave'){
          priceSaving ? priceSaving.style.display = 'none' : '';
        } else{
          priceSaving ? priceSaving.style.display = 'block' : '';
        }
      }
    });

  }

  onPlanTypeChange(value) {
    var detailsModal = this.querySelector('[data-subscribe-modal-trigger]');
    if(value == "onetime") {
      if( this.dataset.section == "collection" || 
          this.dataset.section == "collection-subscription" || 
          this.dataset.section == "template-subscriptions-collection-one" ||
          this.dataset.section == "template-subscriptions-collection-two" ||
          this.dataset.section == "template-subscriptions-collection-three"
          ) {
        var sp = document.querySelector(`#product-form-${this.dataset.uniqueid} #selling_plan`);
      }else{
        var sp = document.querySelector(`#product-form-${this.dataset.section} #selling_plan`);
      }
      sp.value = '';
      window.gwp_selling_plan = 0;
      this.querySelector('.plan-selector__options--onetime').classList.add('is--active');
      this.querySelector('.plan-selector__options--subscribe').classList.remove('is--active');
      this.querySelector('.plan-selector__subscription-options').classList.remove('is--active');
      
      if(detailsModal) {
        this.querySelector('[data-subscribe-modal-trigger]').parentNode.style.display = "none";
      }

      //   var prodPrice = this.querySelector('.plan-selector__options--onetime').getAttribute('data-prod-price');
      var element = document.querySelector('.plan-selector__options--subscribe');
      if (element && element.hasAttribute('data-tontine-price-a')) {
        var tontineTrafficSplit = element.getAttribute('data-tontine-trafficsplit');
        var tontineMultiArmed = element.getAttribute('data-tontine-multiarmed');
        var storedTontineVariationString = JSON.parse(localStorage.getItem('tontine_variation'));
        const tontineInput = document.querySelector('#tontineBValue');
        const offerPrice = element.getAttribute('data-tontine-std-price');
        if (tontineMultiArmed === 'true') {
          const variation = storedTontineVariationString[tontineTrafficSplit].mab;
          if (variation === 'a') {
            var prodPrice = element.getAttribute('data-tontine-price-a');
          }
          if (variation === 'b') {
            var prodPrice = element.getAttribute('data-tontine-price-b');
            tontineInput.value = offerPrice;
          }
          if (variation === 'c') {
            var prodPrice = element.getAttribute('data-tontine-price-c');
          }
          if (variation === 'd') {
            var prodPrice = element.getAttribute('data-tontine-price-d');
          }
        } else {
          const variation = storedTontineVariationString[tontineTrafficSplit].std;
          if (variation === 'a') {
            var prodPrice = element.getAttribute('data-tontine-price-a');
          }
          if (variation === 'b') {
            var prodPrice = element.getAttribute('data-tontine-price-b');
            tontineInput.value = offerPrice;
          }
        }
      } else {
        var prodPrice = element.getAttribute('data-prod-price');
      }
      $('[data-button-price]').hide();
      $('[data-button-compare-price]').text('');
      
    }else{


      this.querySelector('.plan-selector__options--onetime').classList.remove('is--active');
      this.querySelector('.plan-selector__options--subscribe').classList.add('is--active');
      this.querySelector('.plan-selector__subscription-options').classList.add('is--active');
      // this.querySelectorAll('.plan-selector__subscription-options input')[1].click();
      this.querySelector('select[data-single-plan-selector]').value = $('[data-single-plan-selector] option').first().attr('value');
      this.querySelector('select[data-single-plan-selector]').dispatchEvent(new Event('change'));

      if(detailsModal) {
        this.querySelector('[data-subscribe-modal-trigger]').parentNode.style.display = "block";
      }

      //get first item and select it.

      var prodPrice = this.querySelector('.plan-selector__options--subscribe').getAttribute('data-prod-price');
      var comparePrice = $('.plan-selector__options--subscribe').attr('data-prod-compare-price');
      var element = document.querySelector('.plan-selector__options--subscribe');
      if (element && element.hasAttribute('data-tontine-price-a')) {
        var tontineTrafficSplit = element.getAttribute('data-tontine-trafficsplit');
        var tontineMultiArmed = element.getAttribute('data-tontine-multiarmed');
        var storedTontineVariationString = JSON.parse(localStorage.getItem('tontine_variation'));
        const tontineInput = document.querySelector('#tontineBValue');
        const offerPrice = element.getAttribute('data-tontine-offer-price');
        if (tontineMultiArmed === 'true') {
          const variation = storedTontineVariationString[tontineTrafficSplit].mab;
          if (variation === 'a') {
            var comparePrice = element.getAttribute('data-tontine-price-a');
          }
          if (variation === 'b') {
            var comparePrice = element.getAttribute('data-tontine-price-b');
            tontineInput.value = offerPrice;
          }
          if (variation === 'c') {
            var comparePrice = element.getAttribute('data-tontine-price-c');
          }
          if (variation === 'd') {
            var comparePrice = element.getAttribute('data-tontine-price-d');
          }
        } else {
          const variation = storedTontineVariationString[tontineTrafficSplit].std;
          if (variation === 'a') {
            var comparePrice = element.getAttribute('data-tontine-price-a');
          }
          if (variation === 'b') {
            var comparePrice = element.getAttribute('data-tontine-price-b');
            tontineInput.value = offerPrice;
          }
          var discountedPrice = parseFloat(comparePrice.replace('$', ''));
          var discountvalue = element.getAttribute('data-tontine-savings');
          var discountPercentage = Number(discountvalue);
          if (!isNaN(discountedPrice) && !isNaN(discountPercentage)) {
            // Calculate the final price
            var prodPrice = `$${(discountedPrice * discountPercentage).toFixed(2).replace('.00', '')}`;
          }
        }
      } else {
        var prodPrice = element.getAttribute('data-prod-price');
      }
      $('[data-button-price]').text(prodPrice);
      $('[data-button-compare-price]').text(comparePrice);
      $('[data-button-price]').show();

    }

    this.setPrice(prodPrice);



    

  }

  onPlanOptionChange() {

  }


}

customElements.define('plan-selector', PlanSelector);

